import { Heading1 } from "@/components/podkit/typography/Headings";
import type { FC, ReactNode } from "react";

type AutomationsPageHeaderProps = {
    actions?: ReactNode;
};

export const AutomationsPageHeader: FC<AutomationsPageHeaderProps> = ({ actions }) => {
    return (
        <div className="flex min-w-0 items-center justify-between">
            <Heading1>Automations</Heading1>
            {actions}
        </div>
    );
};
